/*
 * @Author: 吴文洁
 * @Date: 2020-01-09 16:45:09
 * @LastEditors: fangpu
 * @LastEditTime: 2023-08-17 16:18:34
 * @Description:
 */
import CONFIG from '@/common/config';
import getActivityType from '@/common/utils/getActivityType';
import dealRouterPath from '@/common/filters/dealRoutePath';
import getUrlParam from "@/common/utils/getUrlParam";

export default function getRedirectUrl(qrCodeUrl?: string) {
  const env: string = (process.env.VUE_APP_DEPLOY_ENV as string) || 'dev';
  const activityType: string = getActivityType();
  let url = '';
  let poseTypeQrCodeUrl = '';
  if (activityType == 'poseType') {
    if (env === 'prod') {
      url = 'https://res.xiaomai5.com/h5/index.html#/';
      poseTypeQrCodeUrl = `https://res.xiaomai5.com/h5/index.html?instId=${getUrlParam('instId')}&from=brandMiniapp&appId=${(CONFIG.appId as any)[env]}#/aienroll?activityId=${getUrlParam("broadcastId")}&type=id`
    } else {
      url = (CONFIG.showUrl as any)[env];
      poseTypeQrCodeUrl = `${(CONFIG.cAppUrl as any)[env]}?instId=${getUrlParam('instId')}&from=brandMiniapp&appId=${(CONFIG.appId as any)[env]}#/aienroll?activityId=${getUrlParam("broadcastId")}&type=id`
    }
  } else {
    if (env === 'prod') {
      url = 'https://res.xiaomai5.com/xmshow/index2.html#/';
    } else {
      url = (CONFIG.showUrl as any)[env];
    }
  }
  const showUrl: string = url + activityType + '/index';
  let location = '';
  let htmlUrl = '';
  if (activityType == 'poseType') {
    location = dealRouterPath(showUrl, 'share') + '&appId=' + (CONFIG.appId as any)[env];

    htmlUrl = poseTypeQrCodeUrl;
  } else {
    location = dealRouterPath(showUrl, 'share') + '&appId=' + (CONFIG.appId as any)[env];

    htmlUrl = qrCodeUrl ? `${qrCodeUrl}&appId=${(CONFIG.appId as any)[env]}` : `${location}&appId=${(CONFIG.appId as any)[env]}`;

  }
  if (env === 'gray' && htmlUrl.indexOf('xmshow/gray') === -1) {
    htmlUrl = htmlUrl.replace('xmshow', 'xmshow/gray');
  }

  if (activityType !== 'distributeType') {
    const redirectUrl =
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
      (CONFIG.appId as any)[env] +
      '&redirect_uri=' +
      encodeURIComponent(htmlUrl || location) +
      '&response_type=code&scope=snsapi_base&state=state#wechat_redirect';
    return redirectUrl;
  }else {
    const redirectUrl =
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
      (CONFIG.appId as any)[env] +
      '&redirect_uri=' +
      encodeURIComponent(htmlUrl || location) +
      '&response_type=code&scope=snsapi_userinfo&state=state#wechat_redirect';
    return redirectUrl;
  }

}
